<template>
	<nav-bar name="Manual"></nav-bar>
	<div id="faq" class="container">
        <tile-info-grid :items="manual"></tile-info-grid>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
    import NavBar from "@/components/NavBar.vue";
    import TileInfoGrid from "@/components/TileInfoGrid.vue";
    import { QuoteItem } from '@/domain/entities/Misc'

	export default defineComponent({
		components: {
			NavBar, TileInfoGrid,
		},
		setup() {
			let manual : QuoteItem[] = [
				{ title: '', message: "bla", image: require("@/assets/lollipop.png") },
				{ title: '', message: "bla", image: "" },
				{ title: '', message: "bla", image: "" },
				{ title: '', message: "bla", image: "" },
			];
			return {
				manual,
			};
		},
	});
</script>